import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import check from "../../../assets/checked.png";
import config from "../../../../config";

const ConnectBox = ({ profile, id, profileId, onConnectionSent, onConnectionCancelled, initialStatus = null }) => {
  const user = useSelector((state) => state.user.userInfo);
  const token = useSelector((state) => state.user.token);
  const [isSending, setIsSending] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [hasSentRequest, setHasSentRequest] = useState(profile?.connectionStatus === 'pending');
  const [notificationId, setNotificationId] = useState(profile?.connectionId || null);
  const handleConnectClick = async () => {
    if (hasSentRequest) {
      await handleCancelRequest();
      return;
    }

    setIsSending(true);

    try {
      const response = await axios.post(
        `${config.baseURL}/api/notifications/send`, 
        {
          receiver_user_id: id,
          receiver_profile_id: profileId,
          sender_user_id: user?.user_id,
          sender_profile_id: user?.profileId,
          type: "connect",
          message: `${user?.first_name} wants to connect with you`,
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      
      toast.success("Connection request sent successfully!");
      setHasSentRequest(true);
      setNotificationId(response.data.insertId);

      if (onConnectionSent) {
        onConnectionSent(id);
      }
      
    } catch (error) {
      console.error("Error sending connection request", error);
      toast.error(error.message || "Failed to send connection request");
    } finally {
      setIsSending(false);
    }
  };  

  const handleCancelRequest = async () => {
    if (!notificationId) return;
    
    setIsCancelling(true);

    try {
      // Option 1: Cancel by notification ID
      await axios.delete(
        `${config.baseURL}/api/notifications/cancel/${notificationId}`,
        {
          data: { userId: user?.user_id },
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      toast.success("Connection request cancelled!");
      setHasSentRequest(false);
      setNotificationId(null);

      if (onConnectionCancelled) {
        onConnectionCancelled(id);
      }
      
    } catch (error) {
      console.error("Error cancelling connection request", error);
      toast.error(error.message || "Failed to cancel connection request");
    } finally {
      setIsCancelling(false);
    }
  };

  return (
    <div className="text-center" id="connectBox">
      <div className="small text-muted mb-2">
        {hasSentRequest && profile.connectionType === "sent"  ? "Request Sent!" : "Like this profile?"}
      </div>
      {hasSentRequest && profile.connectionType === "sent"  ? null :(<img src={check} alt="Check" className="mb-2" style={{ width: "40px" }} />)}
      <div>
        <button 
          className={`btn ${hasSentRequest && profile.connectionType === "sent"  ? 'btn-outline-danger' : 'btn-outline-success'} btn-sm`}
          id="connectBtn" 
          onClick={handleConnectClick}
          style={{cursor: "pointer"}}
          title={hasSentRequest && profile.connectionType === "sent"  ? "Cancel connection request" : "Send connection request"}
          disabled={isSending || isCancelling}
        >
          {isSending ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Sending...
            </>
          ) : isCancelling ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Cancelling...
            </>
          ) : hasSentRequest && profile.connectionType === "sent" ? (
            "Cancel"
          ) : (
            "Add Now"
          )}
        </button>
      </div>
    </div>
  );
};

export default ConnectBox;